import { axiosAjax } from '@app/src/config/axios';
import { PackageModel } from '@app/src/views/Package/listPackage/models/PackageModel';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const packageService = {
  async get(categoryId): Promise<PackageModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_PACKAGE.replace(':categoryId', `${categoryId}`), config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async post(categoryId: number, json: any): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_PACKAGE_PUBLISH.replace(':categoryId', `${categoryId}`), json, config
      );
      if (data.error) {
        throw new Error();
      }
      return data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async getConsume(userId: number, categoryId?: number): Promise<any[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      let urlConsume = process.env.API_MY_PACKAGE
        .replace(':userId', `${userId}`);
      if (categoryId) {
        urlConsume = process.env.API_MY_PACKAGE_CATEGORY
          .replace(':userId', `${userId}`)
          .replace(':categoryId', `${categoryId}`);
      }
      const { data } = await axiosAjax.get(urlConsume, config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
}
